import { IDynamicLinkedServiceTypeMetadata, ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { ConnectionAuthKind, format } from 'shell-models-lib';
import { BuiltInDataSourceOptionId, DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { SSLMode, additionalFieldsKeyOptions, sslModeOptions } from '../consts/postgre-consts';
import { GlobalVariables } from 'app/services/globals';
import { additionalPropertiesInFabricForPostgreSql } from './azure-postgre-sql-metadata';

export const postgreSqlV2Metadata: IDynamicLinkedServiceTypeMetadata = async () => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: __IS_FABRIC_DPE__
            ? adfModelTypeMap.postgreSql.linkedServiceType
            : adfModelTypeMap.postgreSqlV2.linkedServiceType,
        displayName: stringResources.PostgreSql_DisplayText,
        linkedServiceNamePrefix: adfModelTypeMap.postgreSql.linkedServiceType,
        linkedServiceKind: 'table',
        supportedInTrident: true,
        supportAutoFillCopilotInput: true,
        isKnownInPipelineContext: true,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.BuiltIn,
            id: BuiltInDataSourceOptionId.PostgreSql
        },
        supportedAuthKindsInTrident: [ConnectionAuthKind.Basic],
        icon: {
            className: 'svg-i-100x100-PostgreSQL'
        },
        supportOPDG: GlobalVariables.enableOPDG,
        supportOPDGInMirror: GlobalVariables.mirrorPostgreSql,
        supportVNETInMirror: GlobalVariables.mirrorPostgreSql,
        supportCopyJobSource: true,
        supportCopyJobSink: __IS_FABRIC_DPE__,
        supportMultipleIncrementalColumns: true,
        isFirstClass: true,
        fetchTableNameFromItemPath: true,
        supportDatasetV2: true,
        supportFirstClassParameterExperience: true,
        tableColumnNameQuotes: ['"', '"'],
        copySinkTypes: __IS_FABRIC_DPE__ ? [adfModelTypeMap.postgreSql.copySinkType] : [],
        copySourceTypes: [__IS_FABRIC_DPE__ ? adfModelTypeMap.postgreSql.copySourceType : adfModelTypeMap.postgreSqlV2.copySourceType],
        inPreview: 'none',
        category: ['Database'],
        controls: [
            {
                type: 'parameterizable', child: {
                    type: 'textbox',
                    bind: 'server',
                    label: stringResources.ModelName_ServerName,
                    required: true,
                    validators: [
                        { type: 'required', errorMessage: '' }
                    ],
                    isLabelVertical: true
                }
            },
            {
                type: 'parameterizable', child: {
                    type: 'textbox',
                    bind: 'port',
                    label: stringResources.ModelName_Port,
                    isLabelVertical: true,
                    inputType: 'number',
                    min: 0,
                    defaultValue: 5432
                }
            },
            {
                type: 'parameterizable', child: {
                    type: 'textbox',
                    bind: 'database',
                    label: stringResources.ModelName_DatabaseName,
                    required: true,
                    validators: [
                        { type: 'required', errorMessage: '' }
                    ],
                    isLabelVertical: true
                }
            },
            {
                type: 'parameterizable', child: {
                    type: 'textbox',
                    bind: 'userName',
                    label: stringResources.ModelName_UserName,
                    required: true,
                    validators: [
                        { type: 'required', errorMessage: '' }
                    ],
                    isLabelVertical: true
                }
            },
            {
                type: 'dynamic-akv-switcher',
                hideAKVSwitcherInConnStrProps: true,
                enableAKVParameterization: true,
                bind: 'password',
                label: stringResources.ModelName_Password,
                child: {
                    type: 'parameterizable',
                    attribute: 'password',
                    disableAddParameter: true,
                    child: {
                        type: 'password',
                        label: stringResources.ModelName_Password,
                        required: true,
                        isLabelVertical: true,
                        validators: [
                            { type: 'required', errorMessage: '' }
                        ],
                    },
                },
                description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                    format(stringResources.ModelName_LinkedServiceTemplate, stringResources.PostgreSql_DisplayText),
                    stringResources.ModelName_Password)
            },
            {
                type: 'select-switch',
                bind: 'sslMode',
                label: stringResources.SSL_Mode,
                options: sslModeOptions,
                isLabelVertical: true,
                defaultValue: SSLMode.Perfer
            },
            {
                type: 'parameter-config',
                bind: 'parameterizableAdditionalFields',
                label: stringResources.AdditionalConnectionStringFields,
                isLayoutVertical: true,
                isKeyDropdown: true,
                keyOptions: additionalFieldsKeyOptions,
                keyOptionHasType: true,
                dynamicInputTypes: true,
                dynamicInputTypesParameterizable: true,
                keyLabel: stringResources.PropertyName,
                defaultWidth: 250
            }
        ],
        additionalPropertiesInFabric: GlobalVariables.connectionPropertiesForPostgreSql ? additionalPropertiesInFabricForPostgreSql : undefined
    };
    return metadata;
}